export enum NumpadFunctionType {
    backspace = 'backspace',
    submit = 'submit',
}
